<template>
  <div class="stats-cards" id="tab-global-statistic">
    <div class="filters">
      <SharedFilters @change="onChangeSharedFilters"></SharedFilters>
    </div>

    <div class="sections mb-5 mt-5" v-show="isFullPage">

      <div class="card">
        <div class="card-header">
          <h4 class="section-title card-title">{{ $t("Statistic.tabs.global.sections.activity_candidate.title") }}</h4>
        </div>

        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-md-12 text-center">
              <div class="stats-chart activity-candidates teamsquare-highcharts-color">
                <highcharts :options="activityCandidates"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h4 class="section-title card-title">{{ $t("Statistic.tabs.global.sections.using_channels.title") }}</h4>
        </div>

        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-sm-4 text-center">
              <div class="block-statistic m-t-1">
                <span class="number numerator">{{usingChannels['num_candidates_using_app']}}</span>
                <span class="number denominator">/ {{usingChannels['num_active_candidates']}}</span>
                <div> {{ $t('Statistic.tabs.global.sections.using_channels.num_candidates_using_app') }} </div>
              </div>
            </div>

            <div class="col-sm-4 text-center">
              <div class="block-statistic m-t-1">
                <span class="number numerator">{{usingChannels['num_managers_using_app']}}</span>
                <span class="number denominator">/ {{usingChannels['num_active_managers']}}</span>
                <div>{{ $t('Statistic.tabs.global.sections.using_channels.num_manager_using_app') }}</div>
              </div>
            </div>

            <div class="col-sm-4 text-center">
              <div class="block-statistic m-t-1">
                <span class="number numerator">{{usingChannels['num_offers_accepted_sms']}}</span>
                <span class="number percent">({{usingChannels['percent_offer_accepted_sms']}})</span>
                <div>{{ $t('Statistic.tabs.global.sections.using_channels.num_offer_sms') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h4 class="section-title card-title">{{ $t("Statistic.tabs.global.sections.evolution.title") }}</h4>
        </div>
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-sm-12">
              <div class="stats-chart teamsquare-highcharts-color">
                <highcharts :options="candidateEvolution"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SharedFilters from "./shared/Filters";
  import {mapActions, mapGetters} from 'vuex'
  import stats_mixin from '@/mixin/stats'

  export default {
    components: {SharedFilters},
    data() {
      return {
        filters: {
          replaced_occupation_id_in: '',
          replaced_service_id_in: '',
          hub_id_in: '',
          entity_id_in: '',
        }
      }
    },
    mixins: [stats_mixin],
    computed: {
      ...mapGetters({
        activityCandidates: 'stats/activityCandidates',
        usingChannels: 'stats/usingChannels',
        candidateEvolution: 'stats/candidateEvolution',
        isFullPage: 'stats/isFullPage',
        filters_display: 'stats/filters_display',
        servicesOptions: 'users/manageableServices',
        isSingleEntity: 'auth/isSingleEntity',
        occupationsOptions: 'users/manageableOccupations'
      }),
      string_filters() {
        return JSON.stringify(this.filters)
      }
    },
    methods: {
      ...mapActions({
        setStateFilter: 'stats/setStateFilter'
      }),
      onChangeSharedFilters(filterParams) {
        this.filters[filterParams['id']] = filterParams['value'];

      },
      resetSelected: function () {
        this.filters.replaced_occupation_id_in = ''; 
        this.filters.replaced_service_id_in = '';
        this.filters.hub_id_in = '';
      },
      getFilterGlobal() {
        this.$store.dispatch("stats/getActivityCandidates", {filters: this.filters});
        this.$store.dispatch("stats/getUsingChannels", {filters: this.filters});
        this.$store.dispatch("stats/getCandidateEvolution", {filters: this.filters});
      }
    },
    watch: {
      string_filters: {
        handler: function (new_filters, old_filters) {
          let new_filters_json = JSON.parse(new_filters);
          if (old_filters === new_filters ||
            (new_filters_json.entity_id_in === null && this.isSingleEntity)
          ) {
            return false;
          }
          this.getFilterGlobal()
        },
        deep: true
      },
      filters_display: {
        handler: function (new_filters) {
          this.listFilterId(this.filters, new_filters)
        },
        deep: true
      }
    },
  }
</script>

<style scoped>
  .card {
    box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.1);
    margin-top: 40px;
  }
  .card .card-header {
    background: #f7f7f7;
  }
  .card .card-header .card-title {
    font-size: 14px;
  }

  .number {
    font-size: 48px;
    font-weight: bold;
  }

  .block-statistic {}

  .numerator {
    color: #e51349;
    line-height: 48px;
  }

  .denominator {
    color: #0c0c0c;
  }

  .percent {
    color: #0c0c0c;
    font-size: 24px;
    font-weight: 500;
  }

  .using-channels {
    font-size: 16px;
  }

  .using-channels .block-statistic {
    max-width: 250px;
    margin: auto;
    min-height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/stats/TabGlobalStatistic.vue